import { Component, EventEmitter, HostListener, Input, OnInit, Output, OnDestroy, AfterViewInit } from '@angular/core'

import { FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { QuoteService } from 'src/app/service/quote.service';
import { BooleanOptionalBenefitRate, DecimalOptionalBenefitRate, GetQuoteRatesRequestModel, GetQuoteResponseModel, IntOptionalBenefitRate, MemberModel, OptionalBenefitRate, PhoneModel, QuoteRateView, SendQuoteByEmailModel } from 'src/app/service/web-api-client';
declare const bootstrap: any;

@Component({
  selector: 'quote-step4',
  templateUrl: 'quote-step4.component.html',
  styleUrls: ['quote-step4.component.css'],
})
export class QuoteStep4Component implements OnInit, OnDestroy, AfterViewInit {

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  isSectionVisible: boolean = false; // Initially hidden

  toggleSection() {
    this.isSectionVisible = !this.isSectionVisible; // Toggle visibility
  }

  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  progressBarPath: string = '/assets/external/Progress-bar.svg'
  progressBarTransparentPath: string = '/assets/external/Progress-bar-transparent.svg'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectoralt: string = 'Vector3387'
  vectoralt4: string = 'Vector3387'
  ballPink1src: string = '/assets/external/basketball-resize.png'
  ballPink1alt: string = 'BallPink13179'
  towerGrey: string = '/assets/external/tower-resize.png'
  plusFilled: string = '/assets/external/plusFilled.png'

  heartalt: string = 'HeartI3346'
  heartsrc: string = '/assets/external/hearti3346-bq0v.svg'
  dropdownalt: string = 'DropdownI3346'
  dropdownsrc: string = '/assets/external/dropdowni3346-19xn.svg'
  vectorsrc17: string = '/assets/external/vectori3346-fglx.svg'
  worldsrc: string = '/assets/external/worldi3350-ex6g.svg'
  component4src: string = '/assets/external/component4i3350-7ir.svg'
  vectorsrc18: string = '/assets/external/Mask group.svg'

  visible: boolean = false;

  selectedCoverage: any = null;
  selectedCancelTravel: any = null;
  selectedPracticesSport: any = null;
  selectedMedicalCondition: any = null;
  selectedFutureMom: any = null;
  selectedAssistPet: any = null;
  selectedLegalAssist: any = null;

  priceValue: number = 0;
  // durationInDays: number = 0;
  personCount: number = 1;
  geographicalDestination: string = '';
  sendEmailPlan: string = '';

  maximumCoverage: any[] = [
    { name: '$ 50,000', key: '50000' },
    { name: '$ 100,000', key: '100000' },
    { name: '$ 250,000', key: '250000' }
  ];
  cancelTravel: any[] = [
    { name: '$ 0', key: '0' },
    { name: '$ 2,500', key: '2500' }
  ];
  practicesSport: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  medicalCondition: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  futureMom: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  assistPet: any[] = [
    { name: 'No', key: '0' },
    { name: '1', key: '1' },
    { name: '2', key: '2' },
    { name: '3', key: '3' }
  ];
  legalAssist: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];

  isInitialized: boolean;

  maxCoverageRate: number = 0;
  cancellationDueToCatastrophicTripRate: number = 0;
  sportPracticeRate: number = 0;
  preexistingMedicalConditionsRate: number = 0;
  petsRate: number = 0;
  futureMomRate: number = 0;
  legalVIPAssistanceRate: number = 0;
  /** Pestana abierta del acordeon de coberturas opcionales (-1 = todas cerradas; PrimeNG ignora null al actualizar) */
  activeCoverageTab: number = -1;

  planPrimary: QuoteRateView = new QuoteRateView();
  planStandard: QuoteRateView = new QuoteRateView();
  planLight: QuoteRateView = new QuoteRateView();
  
  isBusy: boolean = false;
  sendQuoteByEmailForm: FormGroup;
  emailSendingStatus: number = 0;

  isSticky: boolean = false;
  /** Flecha de scroll (pie del viewport) y cascada de las coberturas opcionales al entrar en pantalla */
  showScrollHint: boolean = false;
  private hintEnabled: boolean = false;
  private hintStage: number = 0;   // 0: lleva a las coberturas; 1: lleva a la tabla de beneficios; 2: ya no se muestra
  private hintBase: number = 0;    // scroll de referencia: la flecha se oculta al bajar 80px desde aqui
  private optObs: IntersectionObserver | null = null;
  @HostListener('window:resize', [])
  onWindowResize() {
    // Al girar o redimensionar: vuelve a medir el hueco de las tarjetas (solo si la barra no esta fija)
    if (this.isSticky) { return; }
    const planDetails = document.getElementById('plandetails');
    const planDetailsShadow = document.getElementById('plandetails-shedow');
    if (planDetails && planDetailsShadow) {
      planDetailsShadow.style.height = '';
      const height = planDetails.offsetHeight;
      if (height > 0) { planDetailsShadow.style.height = height + 'px'; }
    }
  }
  @HostListener('document:scroll', [])
  // onWindowScroll() {
  //   const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  //   if (offset > 800) {
  //     this.isSticky = true;
  //   } else {
  //     this.isSticky = false;
  //   }
  // }
  onWindowScroll() {

    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    // Check if the screen width is less than or equal to 768px (common mobile breakpoint)
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const scrollThreshold = isMobile ? 1400 : 1000; // Adjust threshold for mobile

    this.isSticky = offset > scrollThreshold;
    this.showScrollHint = this.hintEnabled && offset < this.hintBase + 80;

    const planDetails = document.getElementById('plandetails');
    const planDetailsShadow = document.getElementById('plandetails-shedow');
    // El hueco que reserva #plandetails-shedow se mide cada vez que la barra NO esta fija (antes solo una vez: al girar la
    // tableta o cambiar de tamano las tarjetas crecian dentro de un hueco corto y se montaban sobre "Coberturas opcionales")
    if (planDetails && planDetailsShadow && !this.isSticky) {
      const height = planDetails.offsetHeight;
      if (height > 0) { planDetailsShadow.style.height = height + 'px'; }
    }
    
  }
  showDialog() {
    this.visible = true;
  }
  constructor(public quoteService: QuoteService,
    private fb: FormBuilder
  ) {
    this.createForm();
   }

  /** "10 nov – 20 nov 2026" a partir de las fechas yyyy-MM-dd del viaje (sin desfase horario) */
  get tripRangeLabel(): string {
    const parse = (v: any): Date | null => {
      if (!v) { return null; }
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
      if (m) { return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])); }
      const d = new Date(v);
      return isNaN(d.getTime()) ? null : d;
    };
    const a = parse(this.quoteService.quoteModel.tripStartDate);
    const b = parse(this.quoteService.quoteModel.tripEndDate);
    if (!a || !b) { return ''; }
    const M = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const f = (d: Date, withYear: boolean) => d.getDate() + ' ' + M[d.getMonth()] + (withYear ? ' ' + d.getFullYear() : '');
    return f(a, a.getFullYear() !== b.getFullYear()) + ' – ' + f(b, true);
  }

   get durationInDays(): number {
    if (!this.quoteService.quoteModel.tripStartDate || !this.quoteService.quoteModel.tripEndDate) {
      return 0;
    }

    const startDate: Date = new Date(this.quoteService.quoteModel.tripStartDate);
    const endDate: Date = new Date(this.quoteService.quoteModel.tripEndDate);

    if (startDate >= endDate) {
      return 0;
    }

    var diff = Math.abs(endDate.getTime() - startDate.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    return diffDays + 1;
  }
  
  async ngOnInit() {
      
    // Clean up any leftover modal artifacts from previous steps
    this.cleanupModalArtifacts();

      
    this.isInitialized = false;
    // this.quoteService.quoteModel = new GetQuoteResponseModel({"number":"BAQ000015","agentCode":"hello","tripStartDate":"2025-03-31","tripEndDate":"2025-04-04","residenceCountryId":4,"destinationRegionId":4,"applicantBirthdate":"2001-02-01","dependentCount":2,"dependentCountOver65":2,"agreedReceivingOffers":false,"metadata":[]})  
    // this.quoteService.quoteModel.members[0] = new MemberModel({"memberTypeId":1,"firstName":"Mohammed","lastName":"Poolwala","birthdate":"2001-02-01","email":"mohammed.poolwala@yopmail.comd","isDependent":false})
    // this.quoteService.quoteModel.members[0].phones[0] = new PhoneModel({"countryCode":"+355","phoneNumber":"00000000","phoneTypeId":1})

    // this.initAppliesForOwner(this.quoteService.quoteModel.maxCoverage);
    // this.initAppliesForOwner(this.quoteService.quoteModel.cancellationDueToCatastrophicTrip);
    // this.initAppliesForOwner(this.quoteService.quoteModel.sportPractice);
    // this.initAppliesForOwner(this.quoteService.quoteModel.preexistingMedicalConditions);
    // this.initAppliesForOwner(this.quoteService.quoteModel.pets);
    // this.initAppliesForOwner(this.quoteService.quoteModel.futureMom);
    // this.initAppliesForOwner(this.quoteService.quoteModel.legalVipAssistance);

    // this.selectedCoverage = this.getSelectionOrDefault(this.quoteService.quoteModel.maxCoverage.value, this.maximumCoverage);
    // this.selectedCancelTravel = this.getSelectionOrDefault(this.quoteService.quoteModel.cancellationDueToCatastrophicTrip.value, this.cancelTravel);
    // this.selectedPracticesSport = this.getSelectionOrDefault(this.quoteService.quoteModel.sportPractice.value, this.practicesSport);
    // this.selectedMedicalCondition = this.getSelectionOrDefault(this.quoteService.quoteModel.preexistingMedicalConditions.value, this.medicalCondition);
    // this.selectedFutureMom = this.getSelectionOrDefault(this.quoteService.quoteModel.futureMom.value, this.futureMom);
    // this.selectedAssistPet = this.getSelectionOrDefault(this.quoteService.quoteModel.pets.value, this.assistPet);
    // this.selectedLegalAssist = this.getSelectionOrDefault(this.quoteService.quoteModel.legalVipAssistance.value, this.legalAssist);


    
    this.personCount = this.quoteService.quoteModel.dependentCount + this.quoteService.quoteModel.dependentCountOver65 + 1;
    this.geographicalDestination = this.quoteService.quoteModel.destinationRegion.name;
      

    // this.selectedCoverage = this.maximumCoverage[0];
    this.selectedCancelTravel = this.cancelTravel[0];
    this.selectedPracticesSport = this.practicesSport[0];
    this.selectedMedicalCondition = this.medicalCondition[0];
    this.selectedFutureMom = this.futureMom[0];
    this.selectedAssistPet = this.assistPet[0];
    this.selectedLegalAssist = this.legalAssist[0];

    // await this.onSelectedCoverageChange(this.selectedCoverage);
    await this.onSelectedCancelTravelChange(this.selectedCancelTravel);
    //this.onSelectedPracticesSportChange(this.selectedPracticesSport);
    //this.onSelectedMedicalConditionChange(this.selectedMedicalCondition);
    //this.onSelectedFutureMomChange(this.selectedFutureMom);
    await this.onSelectedAssistPetChange(this.selectedAssistPet);
    await this.onSelectedLegalAssistChange(this.selectedLegalAssist);

    const self = this;
    await setTimeout(() => { self.callAPi(); }, 500);

    this.isInitialized = true;
  }

  /** Flecha al pie (>=768) tras 1 s si aun no se ha hecho scroll; y reveal en cascada del acordeon de coberturas al entrar en pantalla */
  private setupOptionsHints(): void {
    if (typeof window === 'undefined') { return; }
    if (window.innerWidth >= 768) {
      setTimeout(() => {
        this.hintEnabled = true;
        this.showScrollHint = (window.pageYOffset || document.documentElement.scrollTop || 0) < 80;
      }, 1000);
    }
    // El acordeon se pinta cuando llegan las tarifas: se reintenta hasta encontrarlo (max. 15 s); si no, se muestra sin animacion
    const tryInit = (left: number) => {
      const acc = document.querySelector('.stups-accordion') as HTMLElement | null;
      const tabs = acc ? acc.querySelectorAll('.p-accordion-tab') : null;
      if (!acc || !tabs || tabs.length === 0) {
        if (left > 0) { setTimeout(() => tryInit(left - 1), 300); }
        else { document.querySelectorAll('.stups-accordion').forEach(a => a.classList.add('opt-in')); }
        return;
      }
      tabs.forEach((tab, i) => (tab as HTMLElement).style.setProperty('--i', String(i)));
      const reveal = (byScroll: boolean) => {
        const first = !acc.classList.contains('opt-in');
        acc.classList.add('opt-in');
        if (this.optObs) { this.optObs.disconnect(); this.optObs = null; }
        if (byScroll && first) { setTimeout(() => this.nudgeFirstOption(), 900); } // tras la cascada, rebote del primer "+"
      };
      if ('IntersectionObserver' in window) {
        this.optObs = new IntersectionObserver((entries) => { if (entries.some(e => e.isIntersecting)) { reveal(true); } }, { threshold: 0.12 });
        this.optObs.observe(acc);
        setTimeout(() => reveal(false), 6000); // red de seguridad: nunca dejar las coberturas invisibles
      } else {
        reveal(false);
      }
    };
    tryInit(50);
  }

  scrollToOptions(): void {
    this.hintEnabled = false;
    this.showScrollHint = false;
    if (this.hintStage === 0) {
      const head = document.querySelector('.options-heading-visible-on-mobile');
      if (head) { head.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      this.hintStage = 1;
      // al llegar: rebote del primer "+" y la flecha vuelve a aparecer para seguir bajando hasta la tabla de beneficios
      setTimeout(() => {
        this.nudgeFirstOption();
        this.hintBase = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.hintEnabled = true;
        this.showScrollHint = true;
      }, 1300);
    } else {
      const table = document.querySelector('.plan-full-info-row') || (document.querySelector('.stups-accordion') as HTMLElement | null)?.nextElementSibling;
      if (table) { table.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      this.hintStage = 2;
    }
  }

  /** Rebote (dos veces) de la fila y del "+" del primer beneficio opcional, como en el paso de viajeros */
  private nudgeFirstOption(): void {
    const acc = document.querySelector('.stups-accordion') as HTMLElement | null;
    if (!acc) { return; }
    acc.classList.remove('opt-nudge');
    void acc.offsetWidth;
    acc.classList.add('opt-nudge');
  }

  nextStep(): void {
    this.onNextStep.emit();
  }
  jumpTpStep(step: number): void {
    this.onNextStep.emit(step);
  }

  prevStep(): void {
    // Clean up modals before going back
    this.cleanupModalArtifacts();
    this.onPrevStep.emit(this.currentStep);
  }

  ngAfterViewInit(): void {
    this.setupOptionsHints();
    // Additional cleanup after view is initialized to catch any lingering modals
    setTimeout(() => {
      this.cleanupModalArtifacts();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.optObs) { this.optObs.disconnect(); this.optObs = null; }
    // Clean up when leaving step 4
    this.cleanupModalArtifacts();
  }

  // onSelectedCoverageChange(newValue: any) {
  //   this.quoteService.quoteRateModel.maxCoverage.value = parseFloat(newValue.key);

  //   if (this.isInitialized) {
  //     this.callAPi();
  //   }
  // }

  onSelectedCancelTravelChange(newValue: any) {
    this.selectedCancelTravel = JSON.parse(JSON.stringify(newValue))

    this.quoteService.quoteRateModel.cancellationDueToCatastrophicTrip.value = parseFloat(this.selectedCancelTravel.key);

    if (this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedPracticesSportChange(newValue: any) {
    this.quoteService.quoteRateModel.sportPractice.value = newValue.key == '1';

    if(this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedMedicalConditionChange(newValue: any) {
    this.quoteService.quoteRateModel.preexistingMedicalConditions.value = newValue.key == '1';

    if(this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedFutureMomChange(newValue: any) {
    this.quoteService.quoteRateModel.futureMom.value = newValue.key == '1';

    if(this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedAssistPetChange(newValue: any) {
    this.quoteService.quoteRateModel.pets.value = parseInt(newValue.key);

    if (this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedAssistPetCounter(newValue: 'plus' | 'minus') {
    const petCount = this.assistPet.length - 1;
    const selectedPetKey = parseInt(this.selectedAssistPet.key);

    let newPetValue: any | null = null;

    // Calculate new pet value based on 'plus' or 'minus'
    if (newValue === 'plus' && selectedPetKey < petCount) {
      newPetValue = this.assistPet[selectedPetKey + 1];
    } else if (newValue === 'minus' && selectedPetKey > 0) {
      newPetValue = this.assistPet[selectedPetKey - 1];
    }

    // If there's a valid new pet value, update the quote model
    if (newPetValue !== null) {
      this.selectedAssistPet = newPetValue
      this.quoteService.quoteRateModel.pets.value = parseInt(newPetValue.key);
    }

    // Call API if initialized
    if (this.isInitialized) {
      this.callAPi();
    }
  }

  onSelectedLegalAssistChange(newValue: any) {
    this.selectedLegalAssist = newValue;
    this.quoteService.quoteRateModel.legalVipAssistance.value = newValue.key == '1';

    if (this.isInitialized) {
      this.callAPi();
      this.activeCoverageTab = -1; // al anadir/quitar la asistencia VIP la pestana se cierra sola
    }
  }

  onOptionalBenefitChanged(optionName: string): void {
    // Cobertura con una sola opcion (solo titular, sin dependientes): al anadirla la pestana se cierra sola.
    // Con dependientes se queda abierta, porque la persona puede querer marcar titular y dependientes.
    if (optionName && this.personCount === 1) {
      const changed: any = (this.quoteService.quoteRateModel as any)[optionName];
      if (changed && changed.appliesForOwner) {
        this.activeCoverageTab = -1;
      }
    }
    // if (!optionName) {
    //   // return;
    // }

    // if (optionName == 'sportPractice') {
    //   if (this.quoteService.quoteModel.sportPractice) {
    //     this.quoteService.quoteModel.sportPractice.value =
    //       this.quoteService.quoteModel.sportPractice.appliesForOwner == true
    //       || this.quoteService.quoteModel.sportPractice.applicableDependentsCount > 0;
    //   }
    // }
    // else if (optionName == 'preexistingMedicalConditions') {
    //   if (this.quoteService.quoteModel.preexistingMedicalConditions) {
    //     this.quoteService.quoteModel.preexistingMedicalConditions.value =
    //       this.quoteService.quoteModel.preexistingMedicalConditions.appliesForOwner == true
    //       || this.quoteService.quoteModel.preexistingMedicalConditions.applicableDependentsCount > 0;
    //   }
    // }
    // else if (optionName == 'futureMom') {
    //   if (this.quoteService.quoteModel.futureMom) {
    //     this.quoteService.quoteModel.futureMom.value =
    //       this.quoteService.quoteModel.futureMom.appliesForOwner == true
    //       || this.quoteService.quoteModel.futureMom.applicableDependentsCount > 0;
    //   }
    // }

    this.callAPi();
  }

  buyingPlan: string | null = null; // plan en proceso de compra: boton "Procesando…" y sin dobles clics
  buyError: string | null = null;   // plan cuyo intento de compra fallo (mensaje bajo el boton)

  async selectPlan(plan: string, redirect: boolean = true, callBack: any = null): Promise<void> {
    if (redirect) {
      if (this.buyingPlan) { return; }
      this.buyingPlan = plan;
      this.buyError = null;
      // si la ventana de "Enviar por correo" quedo abierta, se cierra antes de pasar al pago
      const emailModalEl = document.getElementById('sendQuoteByEmailModal');
      const emailModal = emailModalEl ? bootstrap.Modal.getInstance(emailModalEl) : null;
      if (emailModal) { emailModal.hide(); }
    }
    let selectedPlan = null;
    switch (plan) {
      case 'Primary':
        selectedPlan = this.planPrimary;
        break;
      case 'Standard':
        selectedPlan = this.planStandard;
        break;
      case 'Light':
        selectedPlan = this.planLight;
        break;
      default:
        break;
    }
    if (selectedPlan) {
      const requestModel: GetQuoteRatesRequestModel = GetQuoteRatesRequestModel.getRequest({...this.quoteService.quoteModel, ...this.quoteService.quoteRateModel});
      requestModel.planId = selectedPlan.planId
      // const phoneCode = this.quoteService.quoteModel.applicantPhoneCode
      // const quoteNumber = this.quoteService.quoteModel.quoteNumber
      // const resultJson = JSON.stringify(selectedPlan);
      // this.quoteService.quoteModel = JSON.parse(resultJson);
      // this.quoteService.quoteModel.applicantPhoneCode = phoneCode
      // this.quoteService.quoteModel.quoteNumber = quoteNumber

      await this.quoteService.putRates$(requestModel).subscribe(r => {
        this.quoteService.quoteModel = r;

        // Sync rate breakdown fields (but NOT the whole object) so that
        // later steps (e.g. step 7) can display the selected plan details
        // without mutating dependentsCount or other request metadata.
        if(redirect) {
          const rateModel: any = this.quoteService.quoteRateModel || {};
          if (selectedPlan) {
            rateModel.price = selectedPlan.price ?? rateModel.price;
            rateModel.maxCoverage = selectedPlan.maxCoverage ?? rateModel.maxCoverage;
            rateModel.cancellationDueToCatastrophicTrip = selectedPlan.cancellationDueToCatastrophicTrip ?? rateModel.cancellationDueToCatastrophicTrip;
            rateModel.sportPractice = selectedPlan.sportPractice ?? rateModel.sportPractice;
            rateModel.preexistingMedicalConditions = selectedPlan.preexistingMedicalConditions ?? rateModel.preexistingMedicalConditions;
            rateModel.pets = selectedPlan.pets ?? rateModel.pets;
            rateModel.futureMom = selectedPlan.futureMom ?? rateModel.futureMom;
            rateModel.legalVipAssistance = selectedPlan.legalVipAssistance ?? rateModel.legalVipAssistance;
            this.quoteService.quoteRateModel = rateModel;
          }
        }
        if (redirect) {
          this.buyingPlan = null;
          this.nextStep();  
        }        
        if (callBack) {
          callBack();
        }
      }, (err: any) => {
        // antes un error aqui no hacia nada y el boton parecia muerto
        console.error('putRates', err);
        if (redirect) {
          this.buyingPlan = null;
          this.buyError = plan;
        } else {
          this.isBusy = false;
          this.emailSendingStatus = 3;
        }
      });
     
    }

  }

  private callAPi(): void {
    // console.log("planPrimary", this.planPrimary.init())
    this.quoteService.getConfig$().subscribe(r => {
    })
    var quoteNumber = this.quoteService.quoteModel.number
    // var json: string = JSON.stringify({...this.quoteService.quoteModel});
    const requestModel: GetQuoteRatesRequestModel = GetQuoteRatesRequestModel.getRequest({...this.quoteService.quoteModel, ...this.quoteService.quoteRateModel});

    // requestModel.maxCoverage.rate = 0;
    // requestModel.cancellationDueToCatastrophicTrip.rate = 0;
    // requestModel.sportPractice.rate = 0;
    // requestModel.preexistingMedicalConditions.rate = 0;
    // requestModel.pets.rate = 0;
    // requestModel.futureMom.rate = 0;
    // requestModel.legalVipAssistance.rate = 0;
    // requestModel.quoteNumber = quoteNumber;
    // let phoneCode = this.quoteService.quoteModel.applicantPhoneCode

    // this.quoteService.getQuotes$(requestModel).subscribe(r => {
    //   var resultJson = JSON.stringify(r);
    //   this.quoteService.quoteModel = JSON.parse(resultJson);
    //   this.quoteService.quoteModel.applicantPhoneCode = phoneCode
    //   this.priceValue = this.quoteService.quoteModel.price;
    //   this.durationInDays = this.quoteService.quoteModel.durationInDays;
    //   this.personCount = this.quoteService.quoteModel.dependentCount + this.quoteService.quoteModel.dependentCountOver65 + 1;
      

    //   this.maxCoverageRate = this.quoteService.quoteModel.maxCoverage.rate ?? 0;
    //   this.cancellationDueToCatastrophicTripRate = this.quoteService.quoteModel.cancellationDueToCatastrophicTrip.rate ?? 0;
    //   this.sportPracticeRate = this.quoteService.quoteModel.sportPractice.rate ?? 0;
    //   this.preexistingMedicalConditionsRate = this.quoteService.quoteModel.preexistingMedicalConditions.rate ?? 0;
    //   this.petsRate = this.quoteService.quoteModel.pets.rate ?? 0;
    //   this.futureMomRate = this.quoteService.quoteModel.futureMom.rate ?? 0;
    //   this.legalVIPAssistanceRate = this.quoteService.quoteModel.legalVipAssistance.rate ?? 0;
    // });

    const requestModel1: GetQuoteRatesRequestModel = requestModel;
    requestModel1.planId = 3;
    const plan1 = this.quoteService.getRates$(requestModel1);
    const requestModel2: GetQuoteRatesRequestModel = requestModel;
    requestModel2.planId = 2;
    const plan2 = this.quoteService.getRates$(requestModel2);
    const requestModel3: GetQuoteRatesRequestModel = requestModel;
    requestModel3.planId = 1;
    const plan3 = this.quoteService.getRates$(requestModel3);
    ///Get Quotes
    this.quoteService.allPlans = null; // nunca reutilizar planes de una cotización anterior
    forkJoin([plan1, plan2, plan3]).subscribe(results => {
      this.planPrimary = JSON.parse(JSON.stringify(results[0]))
      this.planStandard = JSON.parse(JSON.stringify(results[1]))

      this.planLight = JSON.parse(JSON.stringify(results[2]))

      // Guardar los 3 planes en el servicio para el PDF de cotización propio
      this.quoteService.allPlans = {
        light:    { ...JSON.parse(JSON.stringify(results[0])), coberturaFija: this.maximumCoverage[0].key },
        standard: { ...JSON.parse(JSON.stringify(results[1])), coberturaFija: this.maximumCoverage[1].key },
        superior: { ...JSON.parse(JSON.stringify(results[2])), coberturaFija: this.maximumCoverage[2].key }
      };

    })

  }

  private initAppliesForOwner(option: OptionalBenefitRate): void {
    if (!option) {
      return;
    }

    if (option.appliesForOwner != true) {
      option.appliesForOwner = false;
    }
  }

  private getSelectionOrDefault(selectedValue: any, array: any[]): any {
    if (!selectedValue && !array) {
      return null;
    }

    const item = array.find(i => i.key == selectedValue);
    if (!item) {
      return array[0];
    }

    return item;
  }

  /**
   * Clean up any leftover modal backdrops and body styles from previous steps
   */
  private cleanupModalArtifacts(): void {
    try {
      // Immediate cleanup
      // Remove all modal backdrops (multiple selectors to catch all variations)
      const backdrops = document.querySelectorAll('.modal-backdrop, .modal-backdrop.fade, .modal-backdrop.show');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });
      
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      
      // Force reset body styles
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      
      // Hide any visible modals (DOM only)
      const visibleModals = document.querySelectorAll('.modal, .modal.show, .modal.fade');
      visibleModals.forEach(modal => {
        modal.classList.remove('show');
        (modal as HTMLElement).style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      });

      // Note: We don't dispose Bootstrap instances here to avoid conflicts with component lifecycle
    } catch (error) {
      console.error('Error cleaning up modal artifacts:', error);
    }
  }

  downloadQuotePdf(plan: string): void {
    if(this.isBusy) {
      return;
    }
    this.isBusy = true;
    let request: GetQuoteResponseModel = null;
    switch (plan) {
      case 'Primary':
        request = JSON.parse(JSON.stringify(this.planPrimary));
        break;
      case 'Standard':
        request = JSON.parse(JSON.stringify(this.planStandard));
        break;
      case 'Light':
        request = JSON.parse(JSON.stringify(this.planLight));
        break;
      default:
        break;
    }

    const self = this;
    this.quoteService.downloadQuoteDocument(request.number)
      .subscribe(file => {
        self.isBusy = false;

        //const blob = new Blob([file.], { type: 'application/json' }); 
        const objectUrl: string = window.URL.createObjectURL(file.data);

        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        a.href = objectUrl;
        a.download = file.fileName ?? 'quote.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);

      }, error => {
          self.isBusy = false;
          console.log('Error Downloading Document');
          console.error(error);
      });
  }
  get canContinue(): boolean {
    return this.sendQuoteByEmailForm.valid && this.validateRecipients(this.sendQuoteByEmailForm.controls.optionalRecipients.value) && this.isBusy != true && this.emailSendingStatus == 0;
  }
  private validateRecipients(value: string): boolean {
    if(!value) {
      return true;
    }
    
    let recipients = value
      .replace(' ', '')
      .replace(';', ',')
      .split(",");

    if(recipients.length == 0) {
      return true;
    }

    for(let email of recipients) {
      var isValid = this.validateEmail(email);
      if(!isValid) {
        return false;
      }
    }

    return true;
  }

  private validateEmail(email: string): boolean {
    let res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(email);
  }
  createForm(): void {
    this.sendQuoteByEmailForm = this.fb.group({
      optionalRecipients: ['']
    });
  }
  openModalSendEmail(plan: string): void {
    this.emailSendingStatus = 0;
    this.sendEmailPlan = plan
    const modalElement = document.getElementById('sendQuoteByEmailModal');
    if (modalElement) {
      // una sola instancia: con "new" cada apertura creaba otra y se acumulaban fondos oscuros
      const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
      modal.show();
    }
  }
   sendEmail(): Promise<void> {
      if(this.isBusy) {
        return;
      }
      this.isBusy = true;
      this.emailSendingStatus = 1;
      const self = this;
      function sendEMailCallback() {
      const json: string = JSON.stringify(self.quoteService.quoteModel);
      let quoteModel: GetQuoteResponseModel = JSON.parse(json);
  
      const request = new SendQuoteByEmailModel({
        recipientEmails: self.sendQuoteByEmailForm.controls.optionalRecipients.value,
        quoteModel: quoteModel
      });
  
      
      self.quoteService.sendQuoteByEmail$(request)
        .subscribe(success => {
          self.isBusy = false;
          self.emailSendingStatus = success
            ? 2
            : 3;
        }, error => {
          // alert('Error sending quote by email');
          self.isBusy = false; // antes quedaba bloqueado y no se podia reintentar
          self.emailSendingStatus = 3
        });
    }
    this.selectPlan(this.sendEmailPlan, false, sendEMailCallback);
  }
  
}
